import { useTranslation } from 'react-i18next'
import {
  LogoWrapper,
  ProducerLogo,
  ScoreLabel,
  ScoreWrapper,
  WineInfoWrapper,
  WineName,
  WineProducer,
  WineProducerText,
  WineSpecification,
  Wrapper,
} from './_styles'
import LogoPlaceholder from 'components/Common/TechListPreview/Icons/LogoPlaceholder'
import FlagIcon from 'components/Common/FlagIcon'
import Score from 'components/Common/Score'
import { delimiter } from 'utils/consts/string'
import {
  formatBottleSize,
  getWineColorString,
  getWineSweetnessString,
  getWineTitleBrand,
  getWineTypeString,
} from 'utils/wine'
import { getScaledImage } from 'utils/screen'

const getProductSpecification = product => {
  const wine = product?.wine

  return [
    getWineTypeString(wine),
    getWineColorString(wine),
    getWineSweetnessString(wine),
    formatBottleSize(product?.bottleSize?.volumeML),
    !product?.packageType?.isDefault
      ? product?.packageType?.localizedName
      : null,
  ]
    .filter(Boolean)
    .join(delimiter)
}

const Header = ({ product, actions }) => {
  const { t } = useTranslation()

  const wine = product?.wine
  const country = wine?.country
  const tradeName = wine?.tradeName?.tradeName
  const h1Text = [country?.localizedName, tradeName].join(', ')
  const wineName = getWineTitleBrand(wine)
  const wineSpecification = getProductSpecification(product)
  const rating = wine?.rating
  const logo = getScaledImage(wine?.tradeName?.logoPreview)

  return (
    <Wrapper>
      <LogoWrapper>
        {logo ? <ProducerLogo src={logo} /> : <LogoPlaceholder size='104px' />}
      </LogoWrapper>

      <WineInfoWrapper>
        <WineProducer>
          <FlagIcon size={17} codeISO={country?.codeISO} />
          <WineProducerText>{h1Text}</WineProducerText>
        </WineProducer>
        <WineName>{wineName}</WineName>
        <WineSpecification>{wineSpecification}</WineSpecification>

        {wine?.techSheet?.isWwlScoreUsed !== false && rating > 0 && (
          <ScoreWrapper>
            <Score value={rating} width={10} height={13} />
            <ScoreLabel>{t('wine.techlist.wwlScore')}</ScoreLabel>
          </ScoreWrapper>
        )}
      </WineInfoWrapper>

      {actions}
    </Wrapper>
  )
}

export default Header
